"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchVendor = fetchVendor;
exports.endpoints = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _requests = require("@edison/requests");

var _utils = require("./utils");

var _constants = require("../utils/constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var endpoints = {
  vendor: {
    method: 'GET',
    url: function url(vendorId) {
      return "/".concat(_constants.API_V1, "/vendor/").concat(vendorId);
    }
  }
};
exports.endpoints = endpoints;

function fetchVendor(_x, _x2) {
  return _fetchVendor.apply(this, arguments);
}

function _fetchVendor() {
  _fetchVendor = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(vendorId, _ref) {
    var auth, optionals, _endpoints$vendor, method, url, res;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            auth = _ref.auth;
            optionals = (0, _utils.withAuth)(auth)(_utils.defaultOptionals);
            _endpoints$vendor = endpoints.vendor, method = _endpoints$vendor.method, url = _endpoints$vendor.url;
            _context.next = 5;
            return (0, _requests.request)(url(vendorId), method, optionals);

          case 5:
            res = _context.sent;
            return _context.abrupt("return", (0, _requests.camelize)(_objectSpread({}, res)));

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchVendor.apply(this, arguments);
}
//# sourceMappingURL=sifts.js.map